import React from "react";
import { motion } from "framer-motion";

const NODES = [
  { label: "Doute", sub: "blocage invisible", tone: "muted" },
  { label: "Écoute", sub: "voix · musique · vibration", tone: "gold" },
  { label: "Intégration", sub: "déplacement intérieur", tone: "gold" },
  { label: "Acte", sub: "geste concret", tone: "bright" },
];

export default function DynamicSchema() {
  return (
    <section
      data-testid="schema-section"
      className="relative py-24 md:py-36 px-6 md:px-10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 md:mb-24">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            05 · Mécanique
          </p>
          <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]">
            Du blocage invisible{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              au geste posé.
            </span>
          </h2>
        </div>

        {/* Flow diagram */}
        <div className="relative bg-obsidian-surface/60 border border-white/[0.06] rounded-3xl p-8 md:p-16">
          {/* Connecting line desktop */}
          <div className="hidden md:block absolute left-[10%] right-[10%] top-1/2 -translate-y-1/2 h-px">
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
              style={{ transformOrigin: "left" }}
              className="h-full w-full bg-gradient-to-r from-ink-400/30 via-gold/70 to-gold"
            />
          </div>

          <div className="relative grid grid-cols-2 md:grid-cols-4 gap-y-12 md:gap-y-0 md:gap-x-6">
            {NODES.map((node, i) => (
              <motion.div
                key={node.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{
                  duration: 0.7,
                  delay: 0.15 + i * 0.15,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="flex flex-col items-center text-center"
                data-testid={`schema-node-${i}`}
              >
                <div
                  className={
                    "relative w-16 h-16 md:w-20 md:h-20 rounded-full flex items-center justify-center mb-6 backdrop-blur-sm " +
                    (node.tone === "muted"
                      ? "bg-obsidian border border-white/15"
                      : node.tone === "gold"
                        ? "bg-obsidian border border-gold/40"
                        : "bg-gold border border-gold")
                  }
                >
                  <span
                    className={
                      "font-display text-xl md:text-2xl " +
                      (node.tone === "bright"
                        ? "text-obsidian"
                        : node.tone === "gold"
                          ? "text-gold"
                          : "text-ink-400")
                    }
                  >
                    0{i + 1}
                  </span>
                  {node.tone !== "muted" && (
                    <span className="absolute inset-0 rounded-full bg-gold/20 animate-ping opacity-30" />
                  )}
                </div>
                <h3
                  className={
                    "font-display text-xl md:text-2xl uppercase tracking-tight mb-2 " +
                    (node.tone === "muted" ? "text-ink-400" : "text-ink-50")
                  }
                >
                  {node.label}
                </h3>
                <p className="font-serif italic text-sm md:text-base text-ink-400 lowercase max-w-[14ch]">
                  {node.sub}
                </p>
              </motion.div>
            ))}
          </div>
        </div>

        <p className="mt-12 md:mt-16 font-serif italic text-xl md:text-2xl text-ink-100/80 max-w-2xl lowercase">
          la confiance ne se construit pas dans la tête. elle se construit
          quand le corps découvre qu'il peut agir.
        </p>
      </div>
    </section>
  );
}
